import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;


export default {
    async usuariosCumple(vm) {
        var formData = new FormData();
        let response = await axios.post(
            `${domain.domainNameForApi}Cumple/usuariosCumple`,
            formData
        );
        return response.data;
    },
    //async usuarioLogeado(vm) {
    //    var formData = new FormData();
    //    let response = await axios.post(
    //        `${domain.domainNameForApi}Cumple/usuarioLogeado`,
    //        formData
    //    );
    //    return response.data;
    //},

    async usuarioLogeado(vm) {
        var formData = new FormData();
        let response = await axios.post(
            `${domain.domainNameForApi}Cumple/usuarioLogeado`,
            formData
        );
        return response.data;
    },
    async obtenerProximosCumples(vm) {
        //Retorna los proximos 6 cumpleaños
        var formData = new FormData();
        let response = await axios.post(
            `${domain.domainNameForApi}Cumple/ProximosCumples`,
            formData
        );
        return response.data;
    },

    

}